import { lazy } from "react";

export const publicRoutes = {
    signin: {
        path: '/login',
        Component: lazy(() => (import('Page/Public/SignIn/SignIn'))),
        public: true,
    },
    forgotPassword: {
        path: '/passwort-vergessen',
        Component: lazy(() => (import('Page/Public/ForgotPassword/ForgotPassword'))),
        public: true,
    },
    register: {
        path: '/registrieren',
        Component: lazy(() => (import('Page/Public/Register/Register'))),
        public: true,
    },
    successRegister: {
        path: '/registrierung-abgesendet',
        Component: lazy(() => (import('Page/Public/SuccessRegister/SuccessRegister'))),
        public: true,
    },
    confirmEmail: {
        path: '/validate-mail',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/ValidateEmail/ValidateEmail'))),
        public: true,
    },
    confirmNewEmail: {
        path: '/validate-new-mail',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/ValidateNewEmail/ValidateNewEmail'))),
        public: true,
    },
    activateAccount: {
        path: '/aktiviere-account',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/ActivateAccount/ActivateAccount'))),
        public: true,
    },
    networkError: {
        path: '/netzwerk-fehler',
        Component: lazy(() => (import('Page/Public/Error/NetworkError'))),
        public: true,
    },
    privacyPolicy: {
        path: '/datenschutz',
        Component: lazy(() => (import('Page/Public/PrivacyPolicy/PrivacyPolicy'))),
        public: true,
    },
    termsOfAgreements: {
        path: '/nutzung',
        Component: lazy(() => (import('Page/Public/TermsOfAgreement/TermsOfAgreement'))),
        public: true,
    },


    validateUser: {
        path: '/freischalten',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/ValidateUser/ValidateUser'))),
        public: true,
    },
    rejectUser: {
        path: '/ablehnen',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/RejectUser/RejectUser'))),
        public: true,
    },
    resetPassword: {
        path: '/reset-password',
        arguments: ['hash'],
        Component: lazy(() => (import('Page/Public/ResetPassword/ResetPassword'))),
        public: true,
    },

}
